import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { RegistrosService } from './../../../../services/API/registros/registros.service';
import { Router } from '@angular/router';
import { NotificationServiceService } from './../../../../services/notification-service/notification-service.service';
import { AuthService } from './../../../../services/API/auth/auth.service';
import { MatSort } from '@angular/material/sort';
import { EditMovimientoComponent } from './../../contenedores/subpages/shared/components/movimientos/edit-movimiento/edit-movimiento.component';
import { finalize } from 'rxjs/operators';

@Component({
    selector: 'app-buscar-registros',
    templateUrl: './buscar-registros.component.html',
    styleUrls: ['./buscar-registros.component.css'],
    standalone: false
})
export class BuscarRegistrosComponent implements OnInit {

  showProgressBar: boolean = false;
  albaran: string = '';
  hasSearched: boolean = false;
  displayedColumns = ['tipo', 'albaran', 'fechaInicio', 'fechaFin', 'transportistas', 'matriculas', 'clasificado'];
  pages = [20, 50, 100];
  filter: string = '';
  dataSource = new MatTableDataSource<any>([]);

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    public authService: AuthService,
    private registrosService: RegistrosService,
    public router: Router,
    private notificationService: NotificationServiceService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.userRolCheck('permiso_registros');
    this.paginator._intl.itemsPerPageLabel = 'Registros por página:';
    this.prepareTable();
  }

  userRolCheck(permission: string) {
    if (!this.authService.userRolCheck(permission)) {
      this.authService.logout();
    }
  }

  searchAlbaran() {
    const albaranNum = parseInt((this.albaran || '').toString().trim(), 10);
    if (!albaranNum || albaranNum <= 0) {
      this.notificationService.openSnackBar('Introduce un número de albarán válido');
      return;
    }

    this.showProgressBar = true;
    this.hasSearched = true;
    this.registrosService.searchRegistros(albaranNum).pipe(
      finalize(() => {
        this.showProgressBar = false;
      })
    ).subscribe({
      next: (result) => {
        const rows = Array.isArray(result) ? result : [];
        this.dataSource.data = rows;
        this.filter = '';
        this.dataSource.filter = '';
        if (rows.length === 0) {
          this.notificationService.openSnackBar('No se encontraron registros para ese albarán');
        }
      },
      error: () => {
        this.dataSource.data = [];
        this.notificationService.openSnackBar('Se ha producido un error al buscar el albarán');
      }
    });
  }

  onSearchKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.searchAlbaran();
    }
  }

  clearAlbaran() {
    this.albaran = '';
  }

  prepareTable() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'fechaInicio':
        case 'fechaFin':
          return this.convertirFecha(item[property]);
        case 'albaran':
          return parseInt(item[property], 10);
        default:
          return item[property];
      }
    };
    this.dataSource.filterPredicate = (data: any, filterValue: string) => {
      const text = (filterValue || '').trim().toLowerCase();
      if (!text) {
        return true;
      }
      return (JSON.stringify(data) || '').toLowerCase().includes(text);
    };
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  verRegistro(element: any) {
    const type = element?.type || 'pesaje';
    const albaran = element?.albaran;

    if (type === 'pesaje') {
      this.router.navigateByUrl('/dashboard/ver-registro/' + albaran);
      return;
    }

    if (type === 'movement') {
      this.dialog.open(EditMovimientoComponent, {
        data: {
          movimiento: element.id,
          tipo: element.typeMovement,
          contenedorEntrega: element.contenedorEntregaID,
          contenedorRetirada: element.contenedorRetiradaID,
          fecha: element.fechaInicio,
          albaran: element.albaran,
          observaciones: element.observaciones,
          cliente: element.cliente,
          latitud: element.latitud,
          longitud: element.longitud,
        },
        width: '90%',
        maxWidth: '500px'
      });
    }
  }

  tipoLabel(element: any): string {
    if (element?.type === 'movement') {
      const labels: Record<string, string> = {
        entrega: 'Contenedor · Entrega',
        retirada: 'Contenedor · Retirada',
        cambio: 'Contenedor · Cambio',
      };
      return labels[element.typeMovement] || 'Contenedor';
    }
    return 'Pesaje';
  }

  convertirFecha(cadena: any) {
    if (!cadena || cadena === '-') {
      return 0;
    }

    const partes = cadena.toString().split(' ');
    const fechaPartes = partes[0].split('-');
    const dia = parseInt(fechaPartes[0], 10);
    const mes = parseInt(fechaPartes[1], 10) - 1;
    const anio = parseInt(fechaPartes[2], 10);

    if (partes.length < 2 || !partes[1]) {
      return new Date(anio, mes, dia).getTime();
    }

    const horaPartes = partes[1].split(':');
    const horas = parseInt(horaPartes[0], 10);
    const minutos = parseInt(horaPartes[1], 10);
    return new Date(anio, mes, dia, horas, minutos).getTime();
  }

}
